import { RouteNames } from '@/data/routes';

// Inactive routes that were removed from routes.js
export enum INACTIVE_ROUTES {
  PLAID = 'payments-profile/connect-banking-plaid',
  BYPASS = 'payments-profile/connect-banking-bypass',
}

export enum EVENT_TYPES {
  LOGIN = 'login',
  ACCOUNT_CREATION = 'account_creation',
}

export const PAGE_IDS: Record<string, string> = {
  [RouteNames.ONBOARDING.USER]: '10',
  [RouteNames.ONBOARDING.INVITED.USER_DETAILS]: '11',
  [RouteNames.ONBOARDING.BUSINESS]: '20',
  [RouteNames.ONBOARDING.INVITED.VERIFICATION]: '22',
  [RouteNames.ONBOARDING.ADDRESS]: '30',
  [RouteNames.BUSINESS.INDEX]: '40',
  [RouteNames.USER.INDEX]: '60',
  [RouteNames.OWNERS.NEW]: '70',
  [INACTIVE_ROUTES.PLAID]: '90',
  [RouteNames.CONNECTED_ACCOUNTS.INDEX]: '100',
  [RouteNames.CONNECTED_ACCOUNTS.MARKETING]: '110',
  [INACTIVE_ROUTES.BYPASS]: '120',
  [RouteNames.TEAM.INDEX]: '130',
};

export const SUB_TYPES: Record<string, string> = {
  [RouteNames.ONBOARDING.USER]: 'onboarding_profile_details',
  [RouteNames.ONBOARDING.BUSINESS]: 'onboarding_business_details',
  [RouteNames.ONBOARDING.ADDRESS]: 'onboarding_registered_address',
  [RouteNames.BUSINESS.INDEX]: 'business_details',
  [RouteNames.USER.INDEX]: 'user_details',
  [RouteNames.OWNERS.NEW]: 'user_add',
  [INACTIVE_ROUTES.PLAID]: 'bank_plaid',
  [RouteNames.CONNECTED_ACCOUNTS.INDEX]: 'revenue_accounts',
  [RouteNames.CONNECTED_ACCOUNTS.MARKETING]: 'marketing_accounts',
  [INACTIVE_ROUTES.BYPASS]: 'bank_manual',
  [RouteNames.ONBOARDING.INVITED.USER_DETAILS]:
    'onboarding_invited_profile_details',
  [RouteNames.ONBOARDING.INVITED.VERIFICATION]:
    'onboarding_invited_profile_verification',
  [RouteNames.TEAM.INDEX]: 'team_edit_user',
};
